import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useCampaignContext } from '@/contexts/CampaignContext';

export const CampaignSelector = () => {
  const { campaigns, activeCampaign, setActiveCampaign } = useCampaignContext();

  return (
    <Select
      value={activeCampaign?.id ?? 'all'}
      onValueChange={setActiveCampaign}>
      <SelectTrigger className="w-[250px]">
        <SelectValue placeholder="Select campaign">
          {activeCampaign?.name ?? 'All'}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All</SelectItem>
        {campaigns?.map((campaign) => (
          <SelectItem
            className="cursor-pointer"
            key={campaign.id}
            value={campaign.id}>
            {campaign.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
